import React from 'react';
import {
  SiPython,
  SiCplusplus,
  SiRust,
  SiGit,
  SiKubernetes,
  SiTerraform,
  SiDocker,
  SiGooglecloud,
  SiGo,
  SiGrafana,
  SiPrometheus,
  SiMqtt,
} from 'react-icons/si';
import { FaJava, FaAws, FaDatabase, FaNetworkWired, FaInfinity } from 'react-icons/fa';
import { VscAzure } from 'react-icons/vsc';
import { TbApi } from 'react-icons/tb';

export default function Skills() {
  const breadthSkills = [
    { name: "Python",   icon: SiPython,    color: "#3776AB" },
    { name: "Java",     icon: FaJava,      color: "#ED8B00" },
    { name: "C/C++",    icon: SiCplusplus, color: "#00599C" },
    { name: "Rust",     icon: SiRust,      color: "#DEA584" },
    { name: "Golang",   icon: SiGo,        color: "#00ADD8" },
    { name: "Database", icon: FaDatabase,  color: "#4169E1" },
    { name: "Docker",   icon: SiDocker,    color: "#2496ED" },
    { name: "Git",      icon: SiGit,       color: "#F05032" },
    { name: "CI/CD",    icon: FaInfinity,  color: "#FF6F00" },
    { name: "MQTT",     icon: SiMqtt,      color: "#660066" },
  ];

  const depthSkills = [
    { name: "AWS",          icon: FaAws,          color: "#FF9900" },
    { name: "Azure",        icon: VscAzure,        color: "#0078D4" },
    { name: "GCP",          icon: SiGooglecloud,   color: "#4285F4" },
    { name: "Kubernetes",   icon: SiKubernetes,    color: "#326CE5" },
    { name: "Terraform",    icon: SiTerraform,     color: "#844FBA" },
    { name: "gRPC",         icon: TbApi,           color: "#4285F4" },
    { name: "Grafana",      icon: SiGrafana,       color: "#F46800" },
    { name: "Prometheus",   icon: SiPrometheus,    color: "#E6522C" },
    { name: "Networking",   icon: FaNetworkWired,  color: "#22C55E" },
  ];

  return (
    <section id="skills" className="scroll-mt-24 space-y-12">
      <div className="lg:hidden text-sm font-bold uppercase tracking-widest text-zinc-200 mb-8 sticky top-0 z-10 w-full bg-zinc-950/90 backdrop-blur pb-4 pt-10">
        Experience
      </div>

      <div className="flex flex-col items-center">
        {/* Breadth - Horizontal Bar */}
        <div className="w-full">
          <p className="text-xs uppercase tracking-widest text-zinc-500 font-semibold mb-6">Breadth / General Knowledge</p>
          <div className="flex flex-wrap gap-2">
            {breadthSkills.map((skill, index) => (
              <div
                key={index}
                className="flex items-center gap-2 px-3 py-1.5 bg-zinc-900 border border-zinc-800 rounded-md text-zinc-300 hover:text-zinc-100 hover:border-zinc-700 transition-colors"
              >
                <skill.icon className="w-4 h-4" style={{ color: skill.color }} />
                <span className="text-xs font-medium tracking-wide">{skill.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Connector Line (visible on md+) */}
        <div className="hidden md:block w-px h-8 bg-zinc-800 my-6"></div>
        <div className="md:hidden h-8"></div>

        {/* Depth - Vertical Stem */}
        <div className="w-full md:w-2/3 lg:w-1/2">
          <p className="text-xs uppercase tracking-widest text-zinc-500 font-semibold mb-6">Depth / Core Expertise</p>
          <div className="flex flex-col gap-2">
            {depthSkills.map((skill, index) => (
              <div
                key={index}
                className="flex items-center gap-4 px-4 py-3 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-300 hover:text-zinc-100 hover:border-zinc-700 transition-colors group"
              >
                <skill.icon className="w-5 h-5 transition-colors" style={{ color: skill.color }} />
                <span className="text-sm font-medium tracking-wide">{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
